export var documentRef = {
  current: typeof document === 'undefined' ? null : document
};
export var windowRef = {
  current: typeof window === 'undefined' ? null : window
};
export { EventListener } from './EventListener';
export * from './types';
export { useEventListener } from './useEventListener';